import { motion } from "framer-motion";
import { MapPin, Users, Store, Truck, ShieldCheck, Timer, BarChart3, Globe2 } from "lucide-react";
import Section, { SectionHeading } from "@/components/Section";

const REASONS = [
  { icon: MapPin, title: "Expansion-Focused" },
  { icon: Users, title: "Manpower-Led Execution" },
  { icon: Store, title: "Dark Store Experience" },
  { icon: Truck, title: "Supply Chain Capability" },
  { icon: ShieldCheck, title: "Compliance-Aware" },
  { icon: Timer, title: "SLA-Driven" },
  { icon: BarChart3, title: "MIS-Led Control" },
  { icon: Globe2, title: "Scalable Multi-City Model" },
];

export default function WhyOneHill() {
  return (
    <Section id="why-onehill" bg="white">
      <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-end mb-12">
        <SectionHeading
          eyebrow="Why OneHill"
          title={<>Quick commerce is won <span className="text-[#99CC00]">on the ground.</span></>}
        />
        <p className="text-lg lg:text-xl leading-relaxed text-neutral-600">
          Apps take orders. Customers see delivery speed. But the real battle is inside the dark store — manpower, SOPs, inventory, compliance and SLA execution.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {REASONS.map((r, i) => (
          <motion.div
            key={r.title}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.45, delay: i * 0.05 }}
            data-testid={`why-card-${i}`}
            className="rounded-3xl border border-neutral-200 bg-white p-6 lg:p-7 shadow-sm hover:-translate-y-1 hover:shadow-xl hover:border-[#99CC00]/40 transition"
          >
            <div className="mb-5 inline-flex p-3 rounded-2xl" style={{ background: "rgba(153,204,0,0.14)" }}>
              <r.icon className="h-7 w-7 text-[#99CC00]" />
            </div>
            <div className="text-lg lg:text-xl font-display font-black text-[#1F1F1F]">{r.title}</div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
